export const LOCKABLE_RESOURCE_HEADER_IDENTIFIER: string = 'X-Lockable-Resource';
